import React, { useState } from 'react'
import { Radio, Input, Checkbox, Tag, message, Modal, Button } from 'antd'
import { markErrors } from '../../../services/api/apiBarcode'
import { getAccessToken } from '../../../services/AuthServices'
import { parseJwt } from '../../../share/parseToken'
import getHistory from '../../../getHistory'

function MarkErrorsModal(props) {
    const {id, isOpen, onClose, reset, onChangeId } = props
    const [errorType, setErrorType] = useState('DANH_DAU_LOI_HONG')
    const [errorSelected, setErrorSelected] = useState([])
    const [selectedWrongTags, setSelectedWrongTags] = useState([])
    const [selectedErrorTags, setSelectedErrorTags] = useState([])
    const [errorInput, setErrorInput] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const handleClose = () => {
        onClose()
        setErrorType('DANH_DAU_LOI_HONG')
        setErrorSelected([])
        setLoading(false)
        setErrorInput('')
        setSelectedErrorTags([])
        setSelectedWrongTags([])
    }

    const markError = async () => {
        setLoading(true)
        const token = getAccessToken()
        const userInfo = !!token && parseJwt(token)
        const {username} = {...userInfo} 
        const payload = {
            error_reason: {
                error_type: errorType,
                error_detail: errorType === 'KHAC' ? errorInput.trim() : errorSelected,
            },
        }
        if(!!username){
            payload.checker = username
        }
        if (!!selectedWrongTags.length || selectedErrorTags.length) {
            payload.printer = {
                side: Array.from(new Set([...selectedWrongTags, ...selectedErrorTags]))
            }
        }

        try {
            const { data: res } = await markErrors(id, payload)
            const { success, message: mess } = res
            const history = getHistory()
            if (!success) {
                setError(mess)
                message.error(mess)
                return
            }
            handleClose()
            reset()
            message.success(`Item đã được đánh dấu lỗi thành công!`)
            onChangeId('')
            history.push("/check")
        } catch (error) {
            message.error(error.message)
        } finally { setLoading(false) }
    }

    const _handleChangeErrorType = (e) => {
        setErrorType(e.target.value)
        setErrorSelected([])
        setSelectedWrongTags([])
        setSelectedErrorTags([])
        setErrorInput('')
    }

    const _handleCheckBoxClick = (value) => {
        setErrorSelected(value)
        setSelectedWrongTags(!value.includes('IN_SAI') ? [] : selectedWrongTags)
        setSelectedErrorTags(!value.includes('IN_LOI') ? [] : selectedErrorTags)
    }

    const _handleTagClick = (tag, type) => {
        if (type === 'Wrong') {
            if (selectedWrongTags.includes(tag)) {
                setSelectedWrongTags(selectedWrongTags.filter((t) => t !== tag))
            } else {
                setErrorSelected(errorSelected.includes('IN_SAI') ? errorSelected : [...errorSelected, 'IN_SAI'])
                setSelectedWrongTags([...selectedWrongTags, tag])
            }
        }
        if (type === 'Error') {
            if (selectedErrorTags.includes(tag)) {
                setSelectedErrorTags(selectedErrorTags.filter((t) => t !== tag))
            } else {
                setErrorSelected(errorSelected.includes('IN_LOI') ? errorSelected : [...errorSelected, 'IN_LOI'])
                setSelectedErrorTags([...selectedErrorTags, tag])
            }
        }
    }
    const _handleChangeInput = (e) => {
        setErrorInput(e.target.value)
    }

    const tagData = [
        { label: 'Front', value: 'FRONT' },
        { label: 'Back', value: 'BACK' },
        { label: 'Sleeve right', value: 'SLEEVE_RIGHT' },
        { label: 'Sleeve left', value: 'SLEEVE_LEFT' },
    ]
    const radioStyle = {
        height: '30px',
        lineHeight: '30px',
    }
    const disableMarkErrorBtn = loading || (errorType !== 'KHAC' && !errorSelected.length) || (errorSelected.includes('IN_SAI') && !selectedWrongTags.length) ||
        (errorSelected.includes('IN_LOI') && !selectedErrorTags.length) || (errorType === 'KHAC' && !errorInput.trim())

    return (
        <div className="ModalEditStatus MarkErrorsModal">
            <Modal
                visible={isOpen}
                onCancel={handleClose}
                title='Đánh dấu item QC lỗi'
                confirmLoading={loading}
                footer={
                    <div className="d-flex justify-content-between">
                        <Button className="btn btn-secondary" disabled={loading} color="secondary" onClick={handleClose}>Hủy</Button>
                        <Button disabled={disableMarkErrorBtn} loading={loading} onClick={markError} color="warning" className="btn btn-warning">
                            Đánh dấu lỗi
                        </Button>
                    </div>
                }
            >
                <div className="errorOption pl-3">
                    <Radio.Group value={errorType} className='w-100 d-flex flex-column' onChange={_handleChangeErrorType}>
                        <div className="radioOption">
                            <Radio style={radioStyle} value={'DANH_DAU_LOI_HONG'}>
                                Đánh dấu lỗi hỏng
                            </Radio>
                            {errorType === 'DANH_DAU_LOI_HONG' &&
                                <Checkbox.Group style={{ width: '100%' }} className='ml-3' value={errorSelected} onChange={_handleCheckBoxClick}>
                                    <div className="d-flex flex-column justify-content-between align-items-start">
                                        <Checkbox className='mx-0 my-1' value="PHOI_O_VANG">Phôi ố vàng</Checkbox>

                                        <Checkbox className='mx-0 my-1' value="PHOI_RACH">Phôi rách</Checkbox>

                                        <div className="d-flex align-items-center w-100">
                                            <Checkbox className='mx-0 my-1 w-40' style={{ width: '20%' }} value="IN_SAI">In sai</Checkbox>
                                            <div>
                                                {!!tagData.length &&
                                                    tagData.map((i, index) => (
                                                        <Tag
                                                            color={selectedWrongTags.includes(i.value) ? '#108ee9' : undefined}
                                                            onClick={() => _handleTagClick(i.value, 'Wrong')}
                                                            className='px-2'
                                                            style={{ fontSize: '12px', borderRadius: '15px' }}
                                                            key={index}
                                                        >
                                                            {i.label}
                                                        </Tag>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center w-100">
                                            <Checkbox className='mx-0 my-1' style={{ width: '20%' }} value="IN_LOI">In lỗi</Checkbox>
                                            <div>
                                                {!!tagData.length &&
                                                    tagData.map((i, index) => (
                                                        <Tag
                                                            color={selectedErrorTags.includes(i.value) ? '#108ee9' : undefined}
                                                            onClick={() => _handleTagClick(i.value, 'Error')}
                                                            className='px-2'
                                                            style={{ fontSize: '12px', borderRadius: '15px' }}
                                                            key={index}
                                                        >
                                                            {i.label}
                                                        </Tag>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Checkbox.Group>
                            }
                        </div>
                        <div className="radioOption">
                            <Radio style={radioStyle} value={'DANH_DAU_SUA_MAY'}>
                                Đánh dấu sửa may
                            </Radio>
                            {errorType === 'DANH_DAU_SUA_MAY' &&
                                <Checkbox.Group style={{ width: '100%' }} className='ml-3' value={errorSelected} onChange={_handleCheckBoxClick} >
                                    <div className="d-flex flex-column justify-content-start align-items-start">
                                        <Checkbox className='mx-0 my-1' value="DUONG_MAY">Đường may</Checkbox>

                                        <Checkbox className='mx-0 my-1' value="MAY_TAY">May tay</Checkbox>
                                    </div>
                                </Checkbox.Group>
                            }
                        </div>
                        <div className="radioOption">
                            <Radio style={radioStyle} value={'KHAC'}>
                                Khác
                            </Radio>
                            {errorType === 'KHAC' ?
                                <Input
                                    style={{ width: '90%' }}
                                    className='ml-3'
                                    placeholder='Nhập lỗi của item'
                                    value={errorInput}
                                    onChange={_handleChangeInput}
                                /> : null
                            }
                        </div>
                    </Radio.Group>
                </div>
                {
                    error && (
                        <div className="text-danger mt-1 pl-3">{error}</div>
                    )
                }
            </Modal>
        </div>
    )
}

export default MarkErrorsModal